import {
  FieldOkConfig,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent,
} from '@softline/dynamic';
import { LagerLagerplatzListView } from './list-view/lager-lagerplatz.list-view';
import { LagerLagerplatzSortedListViewComponent } from './list-view/lager-lagerplatz-sorted-list-view.component';
import { FieldOkSearchConfig } from '@softapps/core/pages';
import { LagerplatzFieldOkSearchResultViewComponent } from './search-result-view/search-result-view.component';

export const lagerLagerplatzFieldOk: FieldOkConfig = {
  name: 'lagerplatz',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{lagerplatz}} - {{bezeichnung}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: LagerLagerplatzSortedListViewComponent,
      title: 'Auswahl',
      config: {
        component: LagerLagerplatzListView,
      },
    },
  ],
};
export const lagerLagerplatzMultiselectFieldOk: FieldOkConfig = {
  name: 'lagerplatz',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{lagerplatz}} - {{bezeichnung}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkMultiselectListViewComponent,
      title: 'Auswahl',
      config: {
        component: LagerLagerplatzListView,
      },
    },
  ],
};

export const lagerLagerplatzQueryFieldOk: FieldOkConfig = {
  name: 'lagerplatz',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{lagerplatz}} - {{bezeichnung}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: QueryFieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: LagerLagerplatzListView,
      },
    },
  ],
};

export const lagerLagerplatzSearchPageConfig: FieldOkSearchConfig<any> = {
  name: 'lagerplatz',
  view: LagerplatzFieldOkSearchResultViewComponent,
  options: {
    autoLoad: true,
  },
};
